import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './rootReducer';
import { startAdvisorySessionWatcher } from './slices/advisory/advisorySession';

// NEW: Import from react-redux
import { useDispatch } from 'react-redux';

// Don't persist auth: it holds the Firebase JWT, which must stay out of
// localStorage. Firebase restores the session on load.
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// Clear any auth token an earlier build may have persisted.
void persistor.purge();

// Starts the Strategic Advisory session's auth-identity watcher exactly
// once, at application bootstrap (the single teardown seat for the
// advisory slice; see advisorySession.ts's module header). The returned
// unsubscribe is deliberately discarded: this subscription is meant to live
// for the application's entire lifetime, so there is no point at which
// calling it would be correct.
startAdvisorySessionWatcher(store);

// Typed state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// NEW: Provide a custom hook for dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();
